import React, { Component } from "react";
import { Form, Checkbox, Header, Icon, Segment } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import PasswordInput from "../PasswordInput";

class AISummaryConfiguration extends Component {
  handleCheckboxChange = (e, { name, checked }) => {
    let { location, onLocationChange } = this.props;

    onLocationChange({ ...location, [name]: checked });
  };

  handleInputChange = e => {
    const { location, onLocationChange } = this.props;
    const { name, value } = e.target;

    onLocationChange({ ...location, [name]: value });
  };

  render() {
    const { location, t } = this.props;

    return (
      <Segment>
        <Header as="h5">
          <Icon name="settings" />
          <Header.Content>{t("ai_summary").message || "AI Summary"}</Header.Content>
        </Header>
        <Segment>
          <Form>
            <Form.Field>
              <Checkbox
                checked={location.generate_ai_summary}
                name="generate_ai_summary"
                label={t("generate_ai_summary").message || "Generate AI Summary"}
                onChange={this.handleCheckboxChange}
              />
            </Form.Field>

            <Form.Field className="full-width-input">
              <label>{t("gen_ai_api_key").message || "Generated AI Api Key"}</label>
              <PasswordInput
                name="gen_ai_api_key"
                placeholder={t("gen_ai_api_key").message || "Generated AI Api Key"}
                value={location.gen_ai_api_key}
                showAsteriskPlaceholder={location.has_gen_ai_api_key}
                disabled={!location.generate_ai_summary}
                onChange={this.handleInputChange}
              />
            </Form.Field>
          </Form>
        </Segment>
      </Segment>
    );
  }
}

export default withTranslation()(AISummaryConfiguration);
